import {createIcon} from '@genestack/ui';
import * as React from 'react';

/**
 * Eye icon
 */
export const EyeIcon = createIcon(
    <svg viewBox="0 0 20 20">
        <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.587 10.162A.834.834 0 013.504 10a.836.836 0 01.083-.162c.083-.133.215-.301.398-.495a9.18 9.18 0 011.533-1.26C6.808 7.22 8.459 6.5 10 6.5c1.54 0 3.193.72 4.482 1.582.64.428 1.17.876 1.533 1.261.183.194.315.362.398.495.055.089.076.141.083.162a.834.834 0 01-.083.162c-.083.133-.215.301-.398.495a9.186 9.186 0 01-1.533 1.26C13.192 12.78 11.541 13.5 10 13.5c-1.54 0-3.193-.72-4.482-1.582a9.184 9.184 0 01-1.533-1.261 3.313 3.313 0 01-.398-.495zM10 5.5c-1.819 0-3.667.835-5.038 1.751-.69.462-1.28.957-1.704 1.406-.211.223-.39.444-.52.651-.118.19-.238.436-.238.692 0 .256.12.502.239.692.129.207.308.428.519.651.424.449 1.014.944 1.704 1.406C6.333 13.665 8.182 14.5 10 14.5c1.819 0 3.667-.835 5.038-1.751a10.17 10.17 0 001.704-1.406c.211-.223.39-.444.52-.651.118-.19.238-.436.238-.692 0-.256-.12-.502-.239-.692a4.289 4.289 0 00-.519-.651 10.17 10.17 0 00-1.704-1.406C13.667 6.335 11.818 5.5 10 5.5zM10 8a2 2 0 100 4 2 2 0 000-4z"
                className="gs-svg-icon-fill"
            />
        </svg>
    </svg>
);
